const vP18316 = require("./121.js");
function f2185(p18317) {
  this.mode = vP18316.NUMERIC;
  this.data = p18317.toString();
}
f2185.getBitsLength = function (p18318) {
  return Math.floor(p18318 / 3) * 10 + (p18318 % 3 ? p18318 % 3 * 3 + 1 : 0);
};
f2185.prototype.getLength = function () {
  return this.data.length;
};
f2185.prototype.getBitsLength = function () {
  return f2185.getBitsLength(this.data.length);
};
f2185.prototype.write = function (p18319) {
  let v14070;
  let v14071;
  let v14072;
  for (v14070 = 0; v14070 + 3 <= this.data.length; v14070 += 3) {
    v14071 = this.data.substr(v14070, 3);
    v14072 = parseInt(v14071, 10);
    p18319.put(v14072, 10);
  }
  const v14073 = this.data.length - v14070;
  if (v14073 > 0) {
    v14071 = this.data.substr(v14070);
    v14072 = parseInt(v14071, 10);
    p18319.put(v14072, v14073 * 3 + 1);
  }
};
module.exports = f2185;